import { useEffect, useRef } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'

import { useBridge } from '@onl-web/shared/bridge'

import { useToast } from '@/components/Toast'
import { LoadingOverlay } from '@/components/ui/LoadingOverlay'
import { readResume, saveResume } from '@/pages/SealedVinylPage/lib/resume'
import { ROUTES } from '@/router/routes'

import { resolveCardRegisterCallback } from './lib/resolveCallback'

/**
 * 카카오 카드 등록 successURL 복귀 중계 페이지.
 *
 * 백엔드가 카카오 등록 승인(approve) 후 이 라우트로 302 redirect 한다 (JSON 반환 ❌):
 *  - 성공: `?paymentMethodId={id}` · 취소: `?status=cancel` · 실패: `?status=fail`
 *
 * 진입 즉시(cold start): 쿼리 + 직전 resume → 새 resume 결정 → 저장 →
 * `/sealed-vinyl` 로 replace navigate. useSealedVinylEntry 가 resume 를 읽어
 * PaymentStep + 수량(직전 저장값) + 새 카드(selectedCardId) 를 복원한다.
 */
export default function CardRegisterCallbackPage() {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const { show: showToast } = useToast()
  const { callHandler } = useBridge()
  const ranRef = useRef(false)

  useEffect(() => {
    if (ranRef.current) return
    ranRef.current = true

    const { resume, toastMessage, registered } = resolveCardRegisterCallback(searchParams, readResume())
    saveResume(resume)
    if (registered) {
      // 카카오 카드 등록 성공 → Flutter 에 결제수단 목록 갱신 알림(1회). 브릿지 미준비여도 흐름 막지 않음.
      void callHandler('on_payment_method_refresh').catch(() => {})
    }
    if (toastMessage) showToast(toastMessage)
    navigate(ROUTES.SEALED_VINYL, { replace: true })
  }, [navigate, searchParams, showToast, callHandler])

  return <LoadingOverlay />
}
